module.exports = __webpack_public_path__ + "img/katarina_events_2.2136f90b.jpg";